<!-- <app-jumbotron title="" background="https://services.ifa.com/art/_dynamic/58_503x627_c_gallerystep-2watching-grass-grow.jpg">    
    <div class="d-flex justify-content-center mb-2"><img src="/assets/images/icons/menu/svg/petition.svg" width="52" height="52" style="padding:3px 6px"><h1 style="font-size: 3rem; line-height: 3rem;padding:0;margin:0">IFA Petition:</h1></div>
      
</app-jumbotron> -->

<app-jumbotron [justify]="'center'" class="transparent" [ngStyle]="{
  'background':'url(https://services.ifa.com/art/_dynamic/58_503x627_c_gallerystep-2watching-grass-grow.jpg', 
  'background-size':'cover',   
  'background-position':'center',   
  'display':'block',
  'box-shadow': 'inset 0 0 0 100vmax rgba(22,104,139,.90)',
  'background-attachment': 'fixed',
  'color':'#fff'
  }" title="IFA Petition" icon="/assets/images/icons/menu/svg/petition.svg">
    <h1 class="h1-Jumbotron">{{title}}</h1>
</app-jumbotron>

<app-banner-dow-one-hundred-k></app-banner-dow-one-hundred-k>


<app-ticker-global-indexes></app-ticker-global-indexes>



<div [ngClass]="{'container-fluid': isSmallOrMediumScreen, 'container': !isSmallOrMediumScreen}" > 
    <div class="row">
        <div class="col-md-8 pe-lg-2 pe-md-1 pe-sm-0 pt-3 pb-5 mb-5 order-md-1 order-2 ">

            <!-- <img src="https://services.ifa.com/art/_dynamic/58_503x627_c_gallerystep-2watching-grass-grow.jpg" alt="Painting of Watching Grass Grow" style="border-radius: 10px;width:100%"> -->
            <!-- <div class="grass-grow-crop mt-3"> -->
            <div class="mt-3">
                <div class="img ratio ratio-16x9">
                    <!-- <iframe width="100%" height="100%" src="https://www.youtube-nocookie.com/embed/ytntth8VyI4?si=QmP-WWS18ULLvR-5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
                    <iframe width="100%" height="100%" src="https://www.youtube.com/embed/sjV0-vLyhTw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
            </div>
            <div class="container m-0 p-0 mt-3">
                <div class="row">
                    <div class="col-lg-2 col-md-3 col-sm-12 col-xs-6 ">Started:</div>
                    <div class="col mb-sm-2 mb-xs-2"><time datetime="2024-02-19 00:00">February 19, 2024</time></div>
                </div>
                <div class="row">
                    <div class="col-lg-2 col-md-3 col-sm-12">Petition to:</div>
                    <div class="col">Financial Media Companies: <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.cnbc.com'}" target="_blank">CNBC</a>, <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.wsj.com/'}" target="_blank">WSJ</a>, <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.marketwatch.com/'}" target="_blank">marketwatch</a>, <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.morningstar.com/'}" target="_blank">Morningstar</a>, <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.barrons.com/'}" target="_blank">Barron's</a>, <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.nytimes.com/'}" target="_blank">NYT</a>, <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.latimes.com/'}" target="_blank">LATIMES</a>, <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.investors.com/'}" target="_blank">InvestorsBusinessDaily</a>, <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.foxbusiness.com/'}" target="_blank">FoxBusiness</a>, <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.bloomberg.com/'}" target="_blank">Bloomberg</a>, <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.spglobal.com/'}" target="_blank">SPGlobal</a>, <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.fool.com/'}" target="_blank">MotleyFool</a></div>
                </div>
            </div>
            <h2>Why this petition matters</h2>
            <div class="d-block clearfix my-3">
                <div class="float-start">
                    <img class="started-by-img me-3" src="https://services.ifa.com/art/images/1482_512x512_c_mark-hebner.jpg">
                    Started by: <a routerLink="/mark">Mark Hebner</a>
                </div>
            </div>
            <p>As the founder and CEO of Index Fund Advisors (IFA.com), a registered investment adviser and wealth management firm celebrating its 25th anniversary in March 2024, I was astonished to learn that the Dow Jones Industrial Average should have been closer to 100,000 when including dividends, rather than the value of around 38,000 in March 2024. Similarly, the S&P 500 should have been at approximately 25,000 instead of the 5,000 it was in March 2024. The S&P 500 25,000 index value assumes a total return index inception date of 1970. See table below which updates to the current index values every day.</p>
            <div style="padding:5px 0 0 0;margin-bottom:20px">
                <app-chart-embed [id]="662" maxWidth="100%"></app-chart-embed>
            </div>
            <!-- <p>As the founder and CEO of Index Fund Advisors (IFA.com), a registered investment adviser and wealth management firm celebrating its 25th anniversary in March 2024, I was astonished to learn that the Dow Jones Industrial Average should be closer to 100,000 when including dividends, rather than the current value of around
                38,000. Similarly, the S&P 500 should be at approximately 25,000 instead of the current 5,000. The S&P 500 25,000 index value assumes a total return index inception date of 1970. See table below:</p>
            <div style="padding:5px 0 0 0;margin-bottom:20px">
                <app-chart-embed [id]="657" maxWidth="100%"></app-chart-embed>
            </div> -->
            <p>This discrepancy is due to most major indexes globally being price-only indexes and not accounting for additional returns earned by investors through dividends. For instance, Germany's DAX has been a total return index since Dec. 1987 and provides an accurate reflection of an investor's total return. DAX calls it a
                performance index versus a price index.</p>
            <p>The impact of this omission is significant; dividends would have increased reported price-only index returns by an estimated annualized return of between two and three percent per year, or approximately twice the cumulative return, over the last quarter-century.</p>
            <p>Therefore, I urge global financial media providers to switch their reporting practices and begin reflecting total return index values starting January 1st, 2026 or sooner. This change should encompass all major indexes worldwide so that investors can be better educated and make more informed decisions of current and
                historical returns of the companies in the index, based on accurate performance data.</p>
            <p>Please sign this petition if you believe in transparency in financial reporting and want global financial media providers to report total return index values no later than January 1, 2026.</p>

            <h2 class="d-inline-block">Notable Support for Total Returns </h2>
            <div class="mt-3 mx-1 mb-5">
                <!-- <h3>Vanguard</h3>
    <blockquote>
        "Price return calculations for indexes are largely a holdover from the early days of indexes. Before computers became ubiquitous, price returns were much simpler to calculate, and so became the default methodology for presenting index returns. Despite many decades of advancements in computing and the advantages of evaluating total returns, price return calculations are still commonly quoted. Vanguard believes that total returns present a more comprehensive assessment of the investor experience, and should be the go-to method for presenting and discussing returns in the capital markets." 
        <br> - Rodney Comegys, Global Head of Equity Index Group at Vanguard
        <time datetime="2024-04-10 00:00"></time>
    </blockquote> -->
                <img class="mb-5" src="https://services.ifa.com/Projects/$versions/6446/(638501588877275009)__Rodney-Comegys_Quote-box.png" style="width:100%" alt="Rodney Comegys, Global Head of Equity Index Group at Vanguard" />
                <img class="mb-5" src="https://services.ifa.com/Projects/$versions/6446/(638501588846460878)__Wes-Crill_Quote-box.png" alt="Wes Crill" style="width:100%" />
                <img class="mb-5" src="https://services.ifa.com/Projects/$versions/6446/(638501588702253335)__Marius-Kerdel_Quote-box.png" alt="Marius Kerdel" style="width:100%" />
                
                
            </div>


            <h2 class="mt-5 d-inline-block">More information on this petition</h2>

            <div class="mt-3 mx-1 mb-5">
                <div class="d-flex justify-content-between">
                    <h3 id="1">1. Professor Samuel H. Hartzmark<a routerLink="./" fragment="1" class="permalink" >(permalink)</a></h3>
                </div>
                <div>
                    <img class="mb-5" src="https://services.ifa.com/Projects/$versions/6446/(638501588808386688)__Samuel-Hartzmark_Quote-box.png" alt="Samuel Hartzmark Quote" style="width:100%" />
                </div>
                <div class="d-flex justify-content-between">
                    <div>
                        <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.nber.org/system/files/working_papers/w27380/w27380.pdf'}" target="_blank">Reconsidering Returns</a>
                        <p>Samuel M. Hartzmark and David H. Solomon<br>
                            NBER Working Paper No. 27380<br>
                            June 2020</p>
                    </div>
                    <div>
                        <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.nber.org/system/files/working_papers/w27380/w27380.pdf'}" target="_blank" class="d-inline-block text-center" style="margin-left:15px"><img src="https://services.ifa.com/art/images/2781-pdf-document.svg" width="60" height="75"
                                alt="pdf document"><br>Download</a>
                    </div>
                </div>




                <p><span class="d-block text-center" style="font-weight: bold; text-decoration: underline;">ABSTRACT</span>
                    Investors' perception of performance is biased because the relevant measure, returns, is rarely
                    displayed. Major indices ignore dividends thereby underreporting market performance.
                    Newspapers are more pessimistic on ex-dividend days, consistent with mistaking the index for
                    returns. Market betas should track returns, but track prices more than dividends, creating
                    predictable returns. Mutual funds receive inflows for “beating the S&P 500,” price index based
                    on net asset value (also not a return). Investors extrapolate market indices, not returns, when
                    forming annual performance expectations. Displaying returns by default would ameliorate these
                    issues, which arise despite high attention and agreement on the appropriate measure.
                </p>

                <div class="img ratio ratio-16x9 mb-3">
                    <a routerLink="/videos/rational-reminder-podcast-samuel-hartzmark" target="_blank"><img class="state-false" src="https://img.youtube.com/vi/CHxNpN-2lmw/maxresdefault.jpg" border="0" width="100%" /></a>
                </div>
                <div>
                    <blockquote>
                        <p>Price Only vs Total Return discussions at
                            <a routerLink="/external.aspx" [queryParams]="{'url':'https://youtu.be/CHxNpN-2lmw?t=3816'}" target="_blank">1:03:33</a> and
                            <a routerLink="/external.aspx" [queryParams]="{'url':'https://youtu.be/CHxNpN-2lmw?t=4502'}" target="_blank">1:15:00</a>.</p>
    
    
    
                        <p><b>Ben Felix:</b> How does reference to price-only data affect the media's coverage of the market?</p>
                        <p>
                            <b>Sam Hartzmark:</b> What's interesting about a price index is that it is predictably and systematically wrong based on how high dividends are that day. That Miller and Modigliani idea of the price dropping by the amount of the dividend that works for firms, it holds for the market. Let's say that the market is
                            paying a dividend yield today of 1%. That means that if you were looking at the total return index, that number you were looking at would be 1% higher than a day with no dividend. Because you should be looking at it, you're looking at the wrong number. What we show in our papers, we look at New York Times media
                            coverage of the market and we say, well, what is the media coverage reflecting? Is it reflecting the actual market performance, the total return? Or is it the fact that reporters are looking at the number that's blaring right out in front of them? Because, again, none of this is secret. The real number is there,
                            but what we find is that financial coverage is significantly more negative, the higher the dividend yield is, controlling for the actual level of performance, which intuitively makes sense. You're looking at the wrong number, you're responding to the wrong number. That's what coverage is actually responding to.
                        </p>
                        <p>
                            Paper reference in this interview: <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.nber.org/system/files/working_papers/w27380/w27380.pdf'}" target="_blank">Hartzmark, Samuel M. and Solomon, David H., Reconsidering Returns (2020)</a>.
                        </p>
    
                    </blockquote>
                </div>
            
                
            </div>

            <!-- <hr class="mb-5"> -->
            <div class="mt-6 mx-1 mb-5">
                <div class="d-flex justify-content-between">
                    <h3 id="2" class="d-inline-block">2. Professor Pankaj Agrrawal<a routerLink="./" fragment="2" class="permalink" >(permalink)</a></h3>
                </div>
                <div>
                    <img class="mb-5" src="https://services.ifa.com/Projects/$versions/6446/(638501588752173754)__Pankaj-Agrrawal_Quote-box.png" alt="Pankaj Agrrawal Quote" style="width:100%" />
                </div>
                <div class="img ratio ratio-16x9 mb-3">
                    <iframe width="100%" height="100%" src="https://www.youtube.com/embed/i4taBs5sQg0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                 </div>
              
                <div class="d-flex justify-content-between">
                    <div>
                        <a routerLink="/external.aspx" [queryParams]="{'url':'https://hdl.handle.net/10419/266247'}" target="_blank">What Is Wrong with this Picture? A Problem with Comparative Return Plots on Finance Websites and a Bias Against Income-Generating Assets</a>
                        <p>Agrrawal, Pankaj and Borgman, Richard<br>
                            Journal of Behavioral Finance<br>ISSN: 1542-7579<br>Volume: 11, Issue: 4<br>Publisher: Taylor & Francis<br>London 2010
                    </div>                   
                   
                    <div>
                        <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.econstor.eu/bitstream/10419/266247/1/Bigcharts 4-25-09-GRS-ver8 preprint to 2010 JBF article.pdf'}" target="_blank" class="d-inline-block text-center" style="margin-left:25px"><img src="https://services.ifa.com/art/images/2781-pdf-document.svg"
                                width="60" height="75" alt="pdf document"><br>Download</a>
                    </div>
                </div>


                <p><span class="d-block text-center" style="font-weight: bold; text-decoration: underline;">ABSTRACT</span>
                    This paper brings to light and discusses a systemic issue in the calculation and display of relative return information as currently seen on some of the most prominent finance websites; income-generating events such as dividends and interest are not included in relative return calculations and all comparative return
                    graphics. The resulting ranking of the securities, based on such incomplete returns, is essentially meaningless from a total return perspective, yet they are being served to millions of investors every day. This could lead to the formation of a possible availability heuristic and an optical bias against fixed-income
                    and other income generating assets. This problem has gone unnoticed for many years with no discussion of the topic either in the academic or practitioner press. The ready availability of such unclear or inaccurate information from sources generally perceived to be credible can, in this age of do-it-yourself portfolio
                    management, have serious and damaging financial consequences to the unsuspecting investor. The paper also shows the effect of this return differential on the calculation of the asset correlation matrices and the subsequent effect on the resulting asset-weight vectors that are used to generate Markowitz style
                    mean-variance portfolios. The visual discrepancies are then supported by the application of the Gibbons, Ross and Shanken [1989] W-test for portfolio efficiency. The authors' proposed correction, based on elementary finance, fixes the problem.
                </p>

                
            </div>



            <div class="mt-6 mx-1 mb-5">
                <div class="d-flex justify-content-between">
                    <h3 id="3" class="d-inline-block">3. Kelly Evans<a routerLink="./" fragment="3" class="permalink" >(permalink)</a></h3>
                </div>
                <div>
                    <img class="mb-5" src="https://services.ifa.com/Projects/$versions/6446/(638519944010124075)__Kelly-Evans_Quote-box.png" alt="Kelly Evans Quote" style="width:100%" />
                </div>
                <p><span class="d-block text-center" style="font-weight: bold; text-decoration: underline;"></span>
                    <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.cnbc.com/2024/05/06/kelly-evans-the-stock-market-has-done-even-better-than-you-think.html'}" target="_blank">&ldquo;So, the S&P is up a healthy 7.5% since January 1. The Dow is up a more modest 2.6%. But here's the catch: those numbers are actually understating the market's true performance by a half-point or so. And this always happens. Why? Because that price performance doesn't include dividends, which actual investors who own the indexes get to pocket--or more crucially, reinvest.  &rdquo;</a>
                </p>
                <div>
                    <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.cnbc.com/2024/05/06/kelly-evans-the-stock-market-has-done-even-better-than-you-think.html'}" target="_blank">Click here to read the whole article.</a>
                </div>
            </div>

            <div class="mt-3 mx-1 mb-5">
                <h3 id="4">4. <a href="https://www.finra.org/rules-guidance/rulebooks/finra-rules/5330" target="_blank">FINRA Rule 5330</a></h3>
                    <p>The Financial Industry Regulatory Authority (FINRA) has a Rule 5330 (<a href="https://www.finra.org/rules-guidance/rulebooks/finra-rules/5330" target="_blank">5330. Adjustment of Ordersfinra.org</a>) that requires broker-dealers to be fair to buyers by adjusting the price overnight downward by the amount of the
                        dividend to be paid BECAUSE, as of that morning, the new buyers will no longer get the dividend. Therefore, the price they pay should be reduced by the dollar amount of the dividend. Here are the key points of the rule:</p>

                    <p>Ex-Dividend, Ex-Rights, Ex-Distribution, and Ex-Interest (Ex refers to Excluding): When a security is quoted ex-dividend, ex-rights, ex-distribution, or ex-interest, broker-dealers must adjust open orders accordingly.</p>

                    <p>The adjustment involves reducing, increasing, or adjusting the price and/or number of shares of the order.</p>

                    <p>For Cash Dividends: ...Open order prices are first reduced by the dollar amount of the dividend...</p>

                    <p>Adherence to Rule 5330 by broker-dealers ensures fair treatment of investors and maintains market integrity. </p>

                    <p>There are 3 dates important for dividends: </p>
                    <ul>
                        <ol>1) Date of Declaration: The date of declaration is when the company's board of directors announces their intention to pay a cash dividend.</ol>
                        <ol>2) Date of Record (and ex-dividend date): The date of record is how the company determines which shareholders are entitled to the dividend.</ol>
                        <ol>3) Date of Dividend Payment.</ol>
                    </ul>

                    <p>Here is an example of how it works:</p>
                    <ul>
                        <ol>1. Let's say a stock will pay a $5 dividend on Wednesday to all shareholders as of Monday and the stock had a closing price of $100 on Monday. At that point the buyers paid the equivalent of $95 for the stock and $5 for the cash dividend.</ol>
                        <ol>2. Tuesday is "excluding-dividend day" and, according to FINRA Rule 5330, the price will be adjusted overnight so that the opening price is adjusted to $95 (because those new buyers will not get the $5 dividend). </ol>
                        <ol>3. Wednesday is the date the $5 dividend is paid to all shareholders who owned the stock on the close of the market on Monday. Those shareholders did not lose $5 as it would appear by looking at the price only, so that $5 must be added back to the price to determine their return on their investment.</ol>
                    </ul>
                    <p>Because FINRA requires broker-dealers to reduce the daily opening price for buyers who won't get a dividend, they should also require the media to display an index that adds back that dividend on the day the price was reduced. Instead, the media shows a price-only index that declines when dividends are paid by the
                        amount of those dividends, which is a wrong measure of total performance since the investor did received dividend and that dividend is a component of their total return. </p>

            </div>

            <div class="mt-3 mx-1 mb-5">
                <h3 id="5">5. <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.slickcharts.com/sp500/returns/details'}" target="_blank">S&P 500 Annual Return Breakdown</a><a routerLink="./" fragment="5" class="permalink" >(permalink)</a></h3>
                Annual Differences Between S&P 500 Price vs Total Return Data
                <div>Sample of Data: <br><a routerLink="/external.aspx" [queryParams]="{'url':'https://www.slickcharts.com/sp500/returns/details '}" target="_blank"><img src="https://services.ifa.com/art/images/2740_2025-1-22-22-23-14.webp" style="width:100%"></a></div>
                <p>Data Details: Detailed S&P 500 return data broken down into price, dividend, and total returns by year. The price return represents the return generated by price changes in the S&P 500 index. The return from reinvesting dividends distributed by the companies in the index is labeled as the dividend return. Total return
                    is the sum of the price return and dividend return.</p>

                <i>Source: <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.slickcharts.com/sp500/returns/details '}" target="_blank">https://www.slickcharts.com/sp500/returns/details</a>, captured on 2025-01-23</i>

            </div>



            <div class="mt-3 mx-1 mb-5">
                <h3 id="6">6. Links to SP Global where you can switch between Price Return and Total Return:<a routerLink="./" fragment="6" class="permalink" >(permalink)</a></h3>
                <ul>
                    <li>Default = Price Return: <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.spglobal.com/spdji/en/indices/equity/dow-jones-industrial-average/'}" target="_blank">DOW</a></li>
                    <li>Default = Price Return: <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.spglobal.com/spdji/en/indices/equity/sp-500/'}" target="_blank">S&P 500</a></li>
                    <li>Default = Price Return: <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.spglobal.com/spdji/en/indices/dividends-factors/sp-500-high-dividend-index/'}" target="_blank">S&P 500 High Dividend Index</a></li>
                    <li>Default = Price Return: <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.spglobal.com/spdji/en/indices/equity/sp-asx-200/'}" target="_blank">S&P/ASX 200</a></li>




                    <li>Default = Total Return: <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.spglobal.com/spdji/en/indices/fixed-income/sp-us-aggregate-bond-index/#overview'}" target="_blank">S&P U.S. Aggregate Bond Index</a></li>
                    <li>Default = Total Return: <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.spglobal.com/spdji/en/indices/multi-asset/sp-target-date-2065-index/#overview'}" target="_blank">S&P Target Date 2065+ Index</a></li>
                    <li>Default = Total Return: <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.spglobal.com/spdji/en/indices/multi-asset/sp-target-date-2025-index/#overview'}" target="_blank">S&P Target Date 2025 Index</a></li>



                </ul>
            </div>

            <div class="mt-3 mx-1 mb-5">
                <h3 id="7">7. Jason Zweig articles on the problems of Price-Only returns:<a routerLink="./" fragment="7" class="permalink" >(permalink)</a></h3>
                <ul>
                    <li><a routerLink="/external.aspx" [queryParams]="{'url':'https://jasonzweig.com/heres-one-way-to-beat-the-market/'}" target="_blank">https://jasonzweig.com/heres-one-way-to-beat-the-market/</a></li>
                    <li><a routerLink="/external.aspx" [queryParams]="{'url':'https://jasonzweig.com/why-we-cant-tell-if-the-market-is-half-empty-or-half-full/'}" target="_blank">https://jasonzweig.com/why-we-cant-tell-if-the-market-is-half-empty-or-half-full/</a></li>
                </ul>
            </div>

            <div class="mt-3 mx-1 mb-5">
                <h3 id="8">8. Dow Jones Industrial Average: Total Return vs Price Return<a routerLink="./" fragment="8" class="permalink" >(permalink)</a></h3>
                <app-chart-embed [id]="649"></app-chart-embed>
            </div>

            <div class="mt-3 mx-1 mb-5">
                <h3 id="9">9. Total Return vs Price-Only Return:<a routerLink="./" fragment="9" class="permalink" >(permalink)</a></h3>

                <div class="mb-4">
                    <app-chart-embed [id]="655"></app-chart-embed>
                </div>
                <div class="mb-4">
                    <app-chart-embed [id]="674"></app-chart-embed>
                </div>
                <div class="mb-4">
                    <app-chart-embed [id]="671"></app-chart-embed>
                </div>
                <div class="mb-4">
                    <app-chart-embed [id]="675"></app-chart-embed>
                </div>
                <div class="mb-4">
                    <app-chart-embed [id]="672"></app-chart-embed>
                </div>
                <div class="mb-4">
                    <app-chart-embed [id]="673"></app-chart-embed>
                </div>
                <div class="mb-4">
                    <app-chart-embed [id]="682"></app-chart-embed>
                </div>
                <div class="mb-4">
                    <app-chart-embed [id]="665"></app-chart-embed>
                </div>
                <div class="mb-4">
                    <app-chart-embed [id]="664"></app-chart-embed>
                </div>


            </div>







            <div class="mt-3 mx-1 mb-5">
                <h3 id="10">10. Return Explanations:<a routerLink="./" fragment="10" class="permalink" >(permalink)</a></h3>
                
                
                <div style="transform:scale(1.3);clear:both;height:auto;display:block; font-weight: bold;margin:30px 0 70px 100px">
                    <div style="display:inline-block; padding:10px; line-height: 40px;position: relative;bottom:21px">Price Return = </div>
                    <div style="display:inline-block; padding:10px;">
                        <div style="border-bottom:2px solid #000; text-align: center;">
                            <div>Ending Price&nbsp;&nbsp;&nbsp;<span style="font-size:28px; position:relative;top:3px">&ndash;</span>&nbsp;&nbsp;&nbsp;Starting Price</div>
                            <div>
                                <div style="font-size: 9px; display: inline-block; position: relative; right:65px;bottom:5px">
                                    which excludes dividends<br>
                                    paid to shareholders
                                </div>
                                
                            </div>
                        </div>
                        
                        <div style="text-align: center;margin-top:8px">
                            Starting Price</div>
                    </div>
                </div>



                <div style="transform:scale(1.3);clear:both;height:auto;display:block; font-weight: bold;margin:0 0 30px 100px">
                    <div style="display:inline-block; padding:10px; line-height: 40px;position: relative;bottom:21px">Total Return = </div>
                    <div style="display:inline-block; padding:10px;">
                        <div style="border-bottom:2px solid #000; text-align: center;">
                            <div>Ending Price&nbsp;&nbsp;&nbsp;<span style="font-size:28px; position:relative;top:5px">+</span>&nbsp;&nbsp;&nbsp;Dividends&nbsp;&nbsp;&nbsp;<span style="font-size:28px; position:relative;top:3px">&ndash;</span>&nbsp;&nbsp;&nbsp;Starting Price</div>
                            <div>
                                <div style="font-size: 9px; display: inline-block; position: relative; right:80px; bottom:5px">
                                    which excludes dividends<br>
                                    paid to shareholders
                                </div>
                                <div style="font-size: 9px; display: inline-block;position: relative; right:55px; bottom:5px">
                                    adds back dividends<br>
                                    that were excluded
                                </div>
                            </div>
                        </div>
                        
                        <div style="text-align: center;margin-top:8px">
                            Starting Price</div>
                    </div>
                </div>
            </div>












            <!-- <div class="mt-3 mx-1 mb-5">
                <h3 id="9">9. Stock Total Return Formula:<a routerLink="./" fragment="9" class="permalink" >(permalink)</a></h3>
                <div style="transform:scale(1.3);clear:both;height:auto;display:block; font-weight: bold; margin:40px 0 40px 100px">
                    <div style="display:inline-block; padding:10px; line-height: 40px;">Stock Total Return = </div>
                    <div style="display:inline-block; padding:10px;">
                        <div style="border-bottom:2px solid #000; text-align: center;">(P<sub>end</sub> - P<sub>start</sub>) + Dividend</div>
                        <div style="text-align: center;">
                            P<sub>start</sub></div>
                    </div>
                </div>
            </div> -->

            <div class="mt-3 mx-1 mb-5">
                <h3 id="11">11. Proposal for Morningstar.com<a routerLink="./" fragment="11" class="permalink" >(permalink)</a></h3>
                
                <div class="mb-4">
                    <app-chart-embed [id]="667"></app-chart-embed>
                </div>
            </div>

            <div class="mt-3 mx-1 mb-5">
                <h3 id="12">12. Proposal for SeekingAlpha.com<a routerLink="./" fragment="12" class="permalink" >(permalink)</a></h3>
                
                <div class="mb-4">
                    <app-chart-embed [id]="670"></app-chart-embed>
                </div>
            </div>

            <div class="mt-3 mx-1 mb-5">
                <h3 id="13">13. Investopedia - Total Return Index: Definition, Example, Vs. Price Index - By James Chen:<a routerLink="./" fragment="13" class="permalink" >(permalink)</a></h3>
                <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.investopedia.com/terms/t/total_return_index.asp'}" target="_blank">https://www.investopedia.com/terms/t/total_return_index.asp</a>

            </div>

            <div class="mt-3 mx-1 mb-5">
                <h3 id="14">14. Indexology® Blog - Index Basics: Calculating an Index's Total Return - By Reid Steadman:<a routerLink="./" fragment="14" class="permalink" >(permalink)</a></h3>
                <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.indexologyblog.com/2017/02/07/index-basics-calculating-an-indexs-total-return/'}" target="_blank">https://www.indexologyblog.com/2017/02/07/index-basics-calculating-an-indexs-total-return/</a>

            </div>




            <div class="mt-3 mx-1 mb-5">
                <h3 id="15">15. Bloomberg Indicies using Total Return:<a routerLink="./" fragment="15" class="permalink" >(permalink)</a></h3>

                <div>
                    <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.bloomberg.com/professional/products/indices/equity/#performance'}" target="_blank">Bloomberg mostly lists their own indicies using "Total Return" as the default performance metric</a>
                </div>  
                <div>
                    <a routerLink="/external.aspx" [queryParams]="{'url':'https://www.bloomberg.com/professional/products/indices/equity/#performance'}" target="_blank">
                        <img src="https://services.ifa.com/art/images/2770_2024-3-25-12-55-13.png" alt="bloomberg indicies mostly using total return" style="width:100%;max-width:492px">
                    </a>
                </div>


            </div>

            <div class="mt-3 mx-1 mb-5">
                <h3 id="16">16. <a routerLink="/external.aspx" [queryParams]="{'url':'http://www.wsj.com/finance/stocks/lessons-from-a-three-decade-long-stock-market-disaster-5a0b5435'}" target="_blank">
                        Wall Street Journal: Lessons From a Three-Decade-Long Stock Market Disaster</a><a routerLink="./" fragment="16" class="permalink" >(permalink)</a></h3>
                <blockquote>"Dividends are vital. Over the long run, the compounding effect of reinvesting dividends makes a huge difference to returns. In the past half-century, U.S. stocks turned $100 into $6,200 without dividends (ignoring costs and taxes) while with dividends they would be worth $25,000. The same is true in Japan,
                    where the 2% yield from dividends is now much higher than in the U.S. An investor who made the dire decision to buy at the top of the bubble and reinvest dividends made back all losses by March 2021. Somehow we forgot to hold a party."</blockquote>
            </div>


            <div class="mt-3 mx-1 mb-5">
                <!-- <h3>Letters of Support:</h3> -->
                <!-- <blockquote data-time="2024-04-02">
                    <p>
                        Dear Mark, <br>
                        From the Old World (The Netherlands) I applaud your petition. It is bizarre and misleading that price indices are reported. I have been urging the media in my country to do the same thing for years. Unfortunately to no avail. I hope you succeed!
                    </p>
                    <p>
                        Warmest regards, <br>
                        Marius Kerdel </p>

                </blockquote>
             -->
            </div>



        </div>
        <div class="col-md-4 mt-4 pt-2 order-md-2 order-1">
            <app-morningstar-total-and-price-returns-disclosure></app-morningstar-total-and-price-returns-disclosure>
            <div class="sticky-top2">
                <div class="m-0 p-0">

                    <div class="row">
                        <div class="col mb-3">
                            <app-morningstar-total-and-price-returns></app-morningstar-total-and-price-returns>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col my-3">

                            <mat-progress-bar mode="determinate" [value]="((count%100/100)*100)"></mat-progress-bar>
                        </div>
                    </div>
                    <div class="row goal">
                        <div class="col mb-5">
                            <div class="text-start">
                                {{count}}<br>
                                <span>Signatures</span>
                            </div>
                        </div>
                        <div class="col  mb-5">
                            <div class="text-end">
                                {{nextGoal}}<br>
                                <span>Next Goal</span>
                            </div>
                        </div>
                    </div>



                </div>


                <ng-container *ngIf="!signed">
                    <h2>Sign This Petition:</h2>
                    <form [formGroup]="userForm" class="example-form" (ngSubmit)="formSubmit()">
                        <mat-form-field class="example-full-width">
                            <mat-label>First Name</mat-label>
                            <input matInput placeholder="First Name" formControlName="name_first">
                            <mat-error *ngIf="userForm.controls['name_first'].invalid && (userForm.controls['name_first'].dirty || userForm.controls['name_first'].touched)" class="errorHint">
                                First Name Required.
                            </mat-error>
                        </mat-form-field>


                        <mat-form-field class="example-full-width">
                            <mat-label>Last Name</mat-label>
                            <input matInput placeholder="Last Name" formControlName="name_last">
                            <mat-error *ngIf="userForm.controls['name_last'].invalid && (userForm.controls['name_last'].dirty || userForm.controls['name_last'].touched)" class="errorHint">
                                Last Name Required.
                            </mat-error>
                        </mat-form-field>
                        <!-- 
                <mat-form-field class="example-full-width">
                    <mat-label>Email</mat-label>
                    <input matInput placeholder="Email" formControlName="email">
                </mat-form-field>

                <mat-form-field class="example-full-width">
                    <mat-label>Phone</mat-label>
                    <input matInput placeholder="Phone" formControlName="phone">
                </mat-form-field>

                <mat-form-field class="example-full-width">
                    <mat-label>City</mat-label>
                    <input matInput placeholder="City" formControlName="city">
                </mat-form-field> -->

                        <mat-form-field class="example-full-width">
                            <mat-label>Country</mat-label>
                            <mat-select formControlName="country">
                                <mat-option *ngFor="let country of countriesLong" [value]="country.name">{{country.name}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <!-- <mat-form-field class="example-full-width">
                    <mat-label>State</mat-label>
                    <input matInput placeholder="State" formControlName="state">
                </mat-form-field>

                <mat-form-field class="example-full-width">
                    <mat-label>Zip Code</mat-label>
                    <input matInput placeholder="Zip Code" formControlName="zip">
                </mat-form-field> -->

                        <!-- <button mat-raised-button class="submit-button" [disabled]="!userForm.valid">Sign this petition</button>   -->



                        <!-- <mat-checkbox formControlName="displayNameOnPetition" class="example-full-width text-center" color="primary">  
                    Display my name on this petition
                  </mat-checkbox>   -->


                        <button mat-raised-button class="submit-button mt-4" style="height:60px">Sign this petition</button>

                        <p class="text-center">Your signature is protected by our <a href="https://www.ifa.com/pdfs/privacypolicy.pdf" target="_blank">Privacy Policy</a>.</p>

                    </form>

                </ng-container>
                <div *ngIf="signed">
                    <h2 class="text-center">Thank you for your support!</h2>
                </div>


                <div class="d-block clearfix my-2">
                    <h2 class="text-center">Share</h2>

                    <div class="pt-1 social-icons text-center">
                        <ul class="">
                            <li (click)="socialsharefacebook()" class="social-share facebook"><i>
                                    <app-facebook></app-facebook>
                                </i></li>
                            <li (click)="socialsharetwitter()" class="social-share twitter"><i>
                                    <app-twitter></app-twitter>
                                </i></li>
                            <li (click)="socialsharelinkedin()" class="social-share linkedin"><i>
                                    <app-linkedin></app-linkedin>
                                </i></li>
                            <li (click)="socialsharereddit()" class="social-share reddit"><i>
                                    <app-reddit></app-reddit>
                                </i></li>
                            <li (click)="emailCurrentPage()" class="social-share email"><i class="fa fa-envelope">
                                    <fa-icon [icon]="faEnvelope" size="1x"></fa-icon>
                                </i></li>
                        </ul>
                    </div>

                </div>
                <div class="d-block clearfix my-2 pt-5">
                    <div class="text-center px-5">
                        <img class="qr p-2" src="../../../../assets/images/qr-codes/petitions-performance-index-vs-price-index.png">
                        <br>
                        Share this petition in person or use the QR code for your own material.<br><a href="../../../../assets/images/qr-codes/petitions-performance-index-vs-price-index.png" target="_blank">Download QR Code</a>
                    </div>

                </div>

            </div>
        </div>
    </div>

</div>